var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v(" @2020 广州易指网络科技有限公司"),_c('br')]),_c('p',[_vm._v("雷电云手机 版权所有")])])}]

export { render, staticRenderFns }